






import { Component, Vue } from "vue-property-decorator";
import { getCurrentPageData } from "../router";

@Component({
  components: {},
})
export default class Page extends Vue {
  htmlContent = '<span class="loading">Loading...</span>';

  created() {
    const page = getCurrentPageData();
    this.htmlContent = page.html;
  }
}
